import { Button, Link, Typography } from '@forgeglobal/design-framework';
import NeedHelp from '@tcs/common/components/atoms/footer/NeedHelp';
import useStyles from './style';

interface ConfirmDenyPageProps {
  confirmClick: () => void;
  cancelClick: () => void;
}

export const ConfirmDenyPage = ({
  confirmClick,
  cancelClick,
}: ConfirmDenyPageProps) => {
  const classes = useStyles();

  return (
    <>
      <Typography variant="h5" className={classes.title}>
        You are choosing to NOT receive documents electronically.
      </Typography>
      <div id="container" className={classes.container}>
        <p>
          Please review the implied change to your account and confirm if you
          would like to proceed with opting out of electronic document delivery.
          You have the option to &quot;Go Back&quot; to the consent screen or if
          you agree to the below you can &quot;confirm&quot; which will take you
          to your online account.
          <ul>
            <li>
              Quarterly statements, tax forms, and account disclosures will be
              physically mailed to your primary address of record.
            </li>
            <li>
              You are responsible for ensuring Forge Trust has your{' '}
              <Link
                href="https://forgetrust.com/forms/account-owner-information-change/"
                data-test-id="prohibited-transactions-button"
                target="_blank">
                correct address{' '}
              </Link>
              so you continue receiving important account documents.
            </li>
            <li>
              You may experience delays in receiving your documents due to
              additional processing and mailing time.
            </li>
            <li>
              Additional charges may apply for electing to receive paper
              documents. Please refer to the{' '}
              <Link
                href="https://forgetrust.com/forms/fee-schedule-and-financial-disclosure/"
                data-test-id="prohibited-transactions-button"
                target="_blank">
                Fee Schedule{' '}
              </Link>
              for further information.
            </li>
          </ul>
          <NeedHelp />
        </p>
      </div>
      <div className={classes.buttons}>
        <Button
          aria-label="go back"
          className={classes.narrowButton}
          variant="text"
          onClick={cancelClick}>
          Go Back
        </Button>
        <Button
          aria-label="confirm"
          className={classes.narrowButton}
          onClick={confirmClick}>
          Confirm
        </Button>
      </div>
    </>
  );
};
